import request from '../base-service';
import type { ResponseGlobalConfigView } from '@/types/global-config';
import { InternalAxiosRequestConfig } from 'axios';
import { ApiResponse } from '@/types/base';
import { RequestNotification } from '../../types/requestNotificaTion';

const BASE_URL = '/v1/notification'

export const notifyApi = {
    list: (model: RequestNotification) =>
        request.post<ApiResponse<ResponseGlobalConfigView>>(
            `${BASE_URL}/getlistnotificationbytoidaction`,
            model,
            {
                authorization: true,
            } as InternalAxiosRequestConfig,
        ),
    counter: (model: RequestNotification) =>
        request.post<ApiResponse<ResponseGlobalConfigView>>(
            `${BASE_URL}/count`,
            model,
            {
                authorization: true,
            } as InternalAxiosRequestConfig,
        ),
    setReadAll: (model: RequestNotification) =>
        request.post<ApiResponse<ResponseGlobalConfigView>>(
            `${BASE_URL}/set-read-all`,
            model,
            {
                authorization: true,
            } as InternalAxiosRequestConfig,
        ),
    setRead: (id: string) =>
        request.post<ApiResponse<ResponseGlobalConfigView>>(
            `${BASE_URL}/set-read`,
            { id },
            {
                authorization: true,
            } as InternalAxiosRequestConfig,
        ),
};
